import { createFileRoute } from '@tanstack/react-router'
import TimeKeeping from '@/features/timekeeping'

export const Route = createFileRoute('/_authenticated/timekeeping/')({
  component: TimeKeeping,
}) 